export default __webpack_public_path__ + "static/media/background-movil.17fea158.png";